var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnvelop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 241,
    viewBox: "0 0 352 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.962 162.895C304.245 168.765 302.086 174.854 297.394 178.605C292.701 182.357 286.286 183.121 280.843 180.577C280.675 180.499 280.507 180.42 280.318 180.332C279.414 184.349 276.74 187.741 273.045 189.558C269.35 191.375 265.031 191.421 261.297 189.684C260.571 189.347 259.877 188.946 259.222 188.486C258.949 189.28 258.635 190.06 258.28 190.821C254.098 199.775 244.899 205.293 235.031 204.767C225.163 204.242 216.602 197.778 213.395 188.431C208.58 193.183 201.751 195.289 195.096 194.075C188.441 192.86 182.796 188.478 179.969 182.333C179.835 182.018 179.509 181.829 179.169 181.87C176.493 182.067 173.81 181.598 171.36 180.504C153.821 174.244 152.527 164.843 128.047 163.555C103.567 162.267 91.4428 149.562 91.4428 149.562C91.4428 149.562 113.499 159.846 128.223 149.988C139.459 142.44 146.447 143.455 148.583 144.317C148.707 144.359 148.844 144.33 148.94 144.243C149.037 144.155 149.079 144.022 149.049 143.894C148.12 140.837 148.91 137.515 151.116 135.203C153.323 132.891 156.603 131.947 159.701 132.731C158.112 129.109 158.313 124.952 160.243 121.499C162.173 118.047 165.61 115.698 169.528 115.155C167.088 107.686 168.929 99.4801 174.326 93.7699C179.724 88.0597 187.813 85.7597 195.407 87.7757C195.578 87.2592 195.78 86.7534 196.011 86.2609C199.31 79.1862 207.719 76.1239 214.795 79.42C215.141 79.5816 215.488 79.7432 215.825 79.9517C215.868 79.8461 215.916 79.7427 215.97 79.6419C219.294 72.5323 225.851 67.4698 233.571 66.054C241.29 64.6381 249.217 67.044 254.848 72.5112C262.968 59.3965 279.906 54.8885 293.472 62.2317C307.037 69.5749 312.523 86.2218 305.982 100.191C313.058 103.491 316.122 111.899 312.828 118.977C311.949 120.872 310.655 122.546 309.043 123.874C319.162 126.209 325.762 135.961 324.168 146.224C322.574 156.487 313.327 163.778 302.976 162.934L302.962 162.895Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.098 87.1926C194.357 87.4709 196.557 88.1083 198.615 89.0805C199.932 89.6946 201.185 90.4393 202.354 91.3036",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M299.58 81.0044C299.68 81.9222 299.704 82.8466 299.653 83.7683",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M291.562 70.668C295.258 71.9892 298.082 75.0225 299.136 78.803",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.632 185.546C192.632 185.546 198.892 188.74 203.877 183.904",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M306.582 98.656C304.619 102.881 301.666 106.57 297.974 109.411",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233.97 133.121C238.183 130.35 243.804 131.179 247.038 135.048C250.273 138.916 250.092 144.595 246.619 148.251C245.764 149.16 244.743 149.897 243.612 150.422",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M260.08 181.751C260.156 184.286 259.78 186.815 258.97 189.218",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M239.634 107.222C244.787 101.349 253.373 99.9375 260.134 103.853C266.896 107.768 269.946 115.918 267.417 123.31C271.005 124.026 273.939 126.602 275.112 130.068C276.286 133.534 275.52 137.363 273.104 140.111",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M267.416 123.31C266.788 125.124 265.861 126.82 264.673 128.329",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M216.974 163.287C215.16 164.924 212.648 165.542 210.282 164.934C207.916 164.326 206.013 162.573 205.213 160.265C199.786 162.752 193.359 161.088 189.82 156.28C186.282 151.472 186.604 144.84 190.592 140.398C186.377 136.128 185.02 129.801 187.114 124.179C189.208 118.556 194.372 114.658 200.354 114.185",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.241 142.197C191.088 139.222 194.088 137.147 197.525 136.47",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M234.108 83.7269C234.866 82.0411 236.764 81.1877 238.528 81.7396C240.291 82.2915 241.364 84.0746 241.026 85.8916C240.945 86.3436 240.776 86.7753 240.529 87.1624",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M241.798 177.989C242.671 180.308 241.669 182.913 239.467 184.05C237.265 185.187 234.561 184.494 233.176 182.439C232.832 181.929 232.586 181.359 232.451 180.759",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M299.418 134.218C301.236 134.568 302.504 136.224 302.368 138.071C302.232 139.917 300.735 141.369 298.885 141.449C298.427 141.471 297.97 141.405 297.537 141.255",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.198 163.123C167.859 163.394 166.48 162.894 165.625 161.827C164.771 160.76 164.584 159.306 165.141 158.058C165.698 156.809 166.905 155.977 168.27 155.9",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4536 141.714L22.0113 197.555C19.9891 196.552 18.5357 194.68 18.0647 192.473L0.960377 111.157C0.491591 108.943 1.06818 106.637 2.5236 104.904L57.4536 141.714Z",
    fill: "#9E59FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M161.965 168.127L135.706 150.518L107.035 131.29L142.47 75.4487C144.503 76.448 145.961 78.328 146.424 80.545L163.528 161.86C164.002 164.079 163.425 166.391 161.965 168.127Z",
    fill: "#9E59FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4536 141.714L22.0113 197.555C19.9891 196.552 18.5357 194.681 18.0647 192.473L0.960377 111.158C0.491591 108.944 1.06818 106.638 2.5236 104.905L57.4536 141.714Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.965 168.127L135.706 150.518L107.035 131.29L142.47 75.4487C144.503 76.448 145.961 78.328 146.424 80.545L163.528 161.86C164.002 164.079 163.425 166.391 161.965 168.127Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.965 168.127L161.93 168.169C161.811 168.302 161.706 168.428 161.587 168.547C161.456 168.685 161.318 168.816 161.173 168.94C161.04 169.066 160.886 169.185 160.738 169.305C160.599 169.411 160.454 169.509 160.304 169.599C160.197 169.672 160.087 169.74 159.974 169.802C159.859 169.872 159.739 169.935 159.617 169.991C159.051 170.277 158.45 170.487 157.829 170.615L26.8342 198.164C26.3224 198.271 25.8007 198.323 25.278 198.319C25.1098 198.319 24.9275 198.319 24.7593 198.319H24.577L24.2475 198.277C24.0611 198.252 23.8761 198.217 23.6938 198.172C23.6565 198.175 23.6189 198.175 23.5816 198.172L23.3082 198.094L23.0138 198.003C22.7865 197.934 22.5641 197.85 22.3478 197.751L22.0745 197.625H22.0254L57.4677 141.783L78.7149 156.028C81.0621 157.59 83.9412 158.137 86.6977 157.544C89.4543 156.951 91.8541 155.269 93.3516 152.88L107.056 131.29L135.727 150.518L161.965 168.127Z",
    fill: "#9E59FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.55 78.4347L137.668 74.8316C139.292 74.4905 140.984 74.7078 142.47 75.4485L128.905 96.8288L93.8557 152.011C92.2031 154.615 89.569 156.442 86.5506 157.077C83.5323 157.712 80.3855 157.101 77.8239 155.383L2.50195 104.911C3.56162 103.632 5.02524 102.752 6.65184 102.416L108.506 80.9864",
    fill: "#FF81AF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M120.55 78.4347L137.668 74.8316C139.292 74.4905 140.984 74.7078 142.47 75.4485L128.905 96.8288L93.8557 152.011C92.2031 154.615 89.569 156.442 86.5506 157.077C83.5323 157.712 80.3855 157.101 77.8239 155.383L2.50195 104.911C3.56162 103.632 5.02524 102.752 6.65184 102.416L108.506 80.9864",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2168 118.574L73.8153 126.831",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6445 113.155L80.4466 127.175",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1875 115.132L82.7602 119.751",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelop);
export default __webpack_public_path__ + "static/media/icon_envelop.f311c94066f9f92da929028b6818859e.svg";
export { ForwardRef as ReactComponent };